export default __webpack_public_path__ + "static/media/016-pharmacy.e9dbf9d1.svg";